<template>
  <div class="d-flex align-items-baseline">
    <span>Latitude:</span>
    <b-form-input
      type="text"
      :value="value.latitude"
      @input="$emit('input', { ...value, latitude: $event })"
      class="mx-2"
    />
    <span>Longitude:</span>
    <b-form-input
      type="text"
      :value="value.longitude"
      @input="$emit('input', { ...value, longitude: $event })"
      class="mx-2"
    />
    <span>Radius:</span>
    <b-form-input
      type="number"
      :value="value.radius / 1000"
      @input="$emit('input', { ...value, radius: $event * 1000 })"
      class="mx-2"
      style="width: 6em"
    />
    <b-button variant="outline-primary" @click="openMap">
      <i class="material-icons">place</i>
    </b-button>
    <b-modal size="lg" ref="modalMap" title="Map" @ok="useMapOptions">
      <b-row class="mb-2">
        <b-col md="3" class="d-flex align-items-baseline">
          <span>Radius:</span>
          <b-form-input type="number" v-model="mapRadius" class="ml-2" />
        </b-col>
        <b-col md="7" class="d-flex align-items-baseline">
          <span>Location:</span>
          <b-form-input
            v-model="location"
            @input="addressChanged = true"
            class="ml-2"
            placeholder="Address"
          />
        </b-col>
        <b-col md="2">
          <b-button
            block
            @click="locate"
            :disabled="!addressChanged || !location"
            class="text-nowrap"
          >
            <b-spinner v-if="geolocating" small class="mr-1" />
            Search
          </b-button>
        </b-col>
      </b-row>
      <div class="gid-map">
        <l-map
          ref="map"
          :zoom="zoom"
          :center="center"
          :options="{ attributionControl: false }"
        >
          <l-tile-layer url="https://{s}.tile.osm.org/{z}/{x}/{y}.png" />
          <l-marker
            :lat-lng="marker"
            @update:latLng="onMarkerDrag"
            :draggable="true"
            :options="{ autoPan: true }"
            @dragend="onMarkerDragEnd"
          />
          <l-circle
            :lat-lng="marker"
            :radius="mapRadius * 1000"
            color="#04a789"
          />
        </l-map>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';

import { LMap, LTileLayer, LMarker, LCircle } from 'vue2-leaflet';

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LCircle,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      zoom: 8,
      center: [this.value.latitude, this.value.longitude],
      marker: [this.value.latitude, this.value.longitude],
      mapRadius: this.value.radius,
      location: '',
      geolocating: false,
      addressChanged: false,
    };
  },
  methods: {
    openMap() {
      this.center = [this.value.latitude, this.value.longitude];
      this.marker = [this.value.latitude, this.value.longitude];
      this.mapRadius = this.value.radius / 1000;
      this.$refs.modalMap.show();
      window.requestAnimationFrame(() => {
        this.$refs.map.mapObject.invalidateSize();
      });
    },
    onMarkerDrag(latlng) {
      this.marker = [latlng.lat, latlng.lng];
    },
    onMarkerDragEnd() {
      this.location = '';
    },
    useMapOptions() {
      this.$emit('input', {
        latitude: Math.round(this.marker[0] * 10000) / 10000,
        longitude: Math.round(this.marker[1] * 10000) / 10000,
        radius: this.mapRadius * 1000,
      });
    },
    locate() {
      this.addressChanged = false;
      this.geolocating = true;
      axios
        .get('https://nominatim.openstreetmap.org/search', {
          params: {
            q: this.location,
            format: 'json',
            limit: 1,
          },
        })
        .then((response) => {
          if (response.data && response.data.length) {
            this.center = this.marker = [
              response.data[0].lat,
              response.data[0].lon,
            ];
          }
          this.geolocating = false;
        })
        .catch(() => {
          this.geolocating = false;
        });
    },
  },
};
</script>
